import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ButtonIcon } from './styles';
import TrashIcon from '../../../../assets/icons/trash.svg?react';
import { theme } from '../../style/theme';
import { DuplicateTag, FileItem, FileLabel, FileSize, RightContainer } from '../ui/files/styles';
import { humanFileSize } from '../ui/files/humanFileSize';

const File = ({ file, onClose, maxSize, duplicate }) => {
    const { t } = useTranslation();
    const isOversized = () => file?.size > maxSize;

    return (
        <FileItem>
            <FileLabel warning={isOversized()} duplicate={duplicate}>
                {file.name}
            </FileLabel>
            <RightContainer>
                {duplicate && <DuplicateTag>{t('uploadSession.alreadyImported')}</DuplicateTag>}
                <FileSize warning={isOversized()}>{humanFileSize(file?.size)}</FileSize>
                <ButtonIcon onClick={() => onClose(file)}>
                    <TrashIcon color={isOversized() ? theme.color.orange.main : theme.color.black.main} />
                </ButtonIcon>
            </RightContainer>
        </FileItem>
    );
};

File.propTypes = {
    file: PropTypes.shape({ name: PropTypes.string, size: PropTypes.number }).isRequired,
    onClose: PropTypes.func,
    maxSize: PropTypes.number,
    duplicate: PropTypes.bool,
};

export default File;
